/**
 * alfavita-kit-quiz.js
 * Controller for the 7-screen personalized-kit qualification quiz.
 * Captures name + email on Screen 7, logs the lead to Notion via the
 * Cloudflare Worker (route /kitquiz), then redirects to the PDP with ?name=.
 * Tracking: Microsoft Clarity only (per brief — no Meta/GA events).
 */
(function () {
  'use strict';

  var wrap = document.getElementById('kq');
  if (!wrap) return;

  /* ---- Config from data attributes (set by the Liquid section) ---------- */
  var WORKER_URL   = (wrap.dataset.worker  || '').trim();
  var WORKER_ROUTE = (wrap.dataset.route   || '/kitquiz').trim();
  var REDIRECT_PATH = (wrap.dataset.redirect || '/pages/custom-ultimate-kitt').trim();
  var SORRY_PATH   = (wrap.dataset.sorry   || '/sorry').trim();
  var CAP_TOTAL    = parseInt(wrap.dataset.capTotal, 10) || 500;
  var CAP_BASE     = parseInt(wrap.dataset.capBase, 10)  || 487;
  var CAP_MIN      = parseInt(wrap.dataset.capMin, 10)   || 19;
  var CAP_VERSION  = (wrap.dataset.capVersion || '1').trim();

  var TOTAL_STEPS = 7;
  var STEP_OF = { s1:1, s2:2, s3:3, s4:4, s5:5, s5b:5, s6:6, s7:7 };

  var answers = {
    age_range:'', time_losing_hair:'', desired_outcome:'',
    commitment_response:'', reframe_response:'', ship_date_response:'',
    customer_name:'', email:''
  };

  var history = [];
  var current = 's1';

  var $ = function (id) { return document.getElementById(id); };

  /* ---- Screen navigation ----------------------------------------------- */
  function render(id) {
    document.querySelectorAll('.kq-screen').forEach(function (s) {
      s.classList.toggle('kq-active', s.id === id);
    });
    var terminal = (id === 'sFinal');
    $('kq-progress').style.visibility = terminal ? 'hidden' : 'visible';
    $('kq-cap').style.visibility      = terminal ? 'hidden' : 'visible';

    if (STEP_OF[id]) {
      var step = STEP_OF[id];
      $('kq-progress-fill').style.width = (step / TOTAL_STEPS * 100) + '%';
      $('kq-progress-label').textContent = 'Paso ' + step + ' de ' + TOTAL_STEPS;
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    track(id);

    if (id === 's4')     runRing();
    if (id === 's6')     setShipDate();
    if (id === 'sFinal') runFinal();
  }

  /* ---- Dynamic ship date: today + 3 days, in Spanish -------------------- */
  function setShipDate() {
    var el = $('kq-ship-date');
    if (!el) return;
    var MESES = ['enero','febrero','marzo','abril','mayo','junio','julio',
                 'agosto','septiembre','octubre','noviembre','diciembre'];
    var d = new Date();
    d.setDate(d.getDate() + 3);
    el.textContent = d.getDate() + ' de ' + MESES[d.getMonth()];
  }

  function go(id)        { history.push(current); current = id; render(id); }
  function replaceTo(id) { current = id; render(id); }   // no history entry (loader skip)
  function back() {
    if (!history.length) return;
    current = history.pop();
    render(current);
  }

  /* ---- Microsoft Clarity tagging (only analytics, per brief) ----------- */
  function track(id) {
    try {
      if (window.clarity) {
        window.clarity('set', 'kit_quiz_screen', id);
        window.clarity('event', 'KitQuiz_' + id);
      }
    } catch (e) { /* never break the quiz on a tracking error */ }
  }

  /* ---- Option clicks (single-select + binary, all auto-advance) -------- */
  function onOption(e) {
    var el   = e.currentTarget;
    var key  = el.dataset.key;
    var next = el.dataset.next;
    if (key) answers[key] = el.dataset.answer;

    el.parentNode.querySelectorAll('.kq-option').forEach(function (s) {
      s.classList.remove('kq-picked');
    });
    el.classList.add('kq-picked');

    setTimeout(function () {
      if (next === 'SORRY') { window.location.href = SORRY_PATH; return; }
      go(next);
    }, 180);
  }

  /* ---- Screen 4: single ring fills 0 -> 100%, then auto-advance -------- */
  var RING_C = 326.73;   // 2 * π * r52
  function runRing() {
    var ring = $('kq-ring'), pct = $('kq-ring-pct');
    if (!ring || !pct) return;
    ring.style.strokeDashoffset = RING_C;
    pct.textContent = '0%';
    var start = null, duration = 2300;
    function tick(ts) {
      if (!start) start = ts;
      var p  = Math.min((ts - start) / duration, 1);
      var ev = 1 - Math.pow(1 - p, 3);
      pct.textContent = Math.round(ev * 100) + '%';
      ring.style.strokeDashoffset = (RING_C * (1 - ev)).toFixed(2);
      if (p < 1) { requestAnimationFrame(tick); }
      else { setTimeout(function () { if (current === 's4') replaceTo('s5'); }, 420); }
    }
    requestAnimationFrame(tick);
  }

  /* ---- Screen 7: validation -------------------------------------------- */
  var NAME_RE  = /^[a-zA-ZÀ-ÿ\s]{1,20}$/;
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function nameOk(v)  { v = (v || '').trim(); return v.length > 0 && NAME_RE.test(v); }
  function emailOk(v) { return EMAIL_RE.test((v || '').trim()); }

  function refreshForm() {
    $('kq-submit').disabled = !(nameOk($('kq-name').value) && emailOk($('kq-email').value));
  }

  function onSubmit(e) {
    e.preventDefault();
    var nameEl = $('kq-name'), emailEl = $('kq-email');
    var name = nameEl.value.trim(), email = emailEl.value.trim();
    var valid = true;

    if (!nameOk(name))  { nameEl.classList.add('kq-invalid');  $('kq-name-error').classList.add('kq-show');  valid = false; }
    if (!emailOk(email)) { emailEl.classList.add('kq-invalid'); $('kq-email-error').classList.add('kq-show'); valid = false; }
    if (!valid) return;

    answers.customer_name = name;
    answers.email = email;

    submitLead();
    go('sFinal');
  }

  /* ---- Submission payload ---------------------------------------------- */
  function buildPayload() {
    return {
      source: window.location.href,
      customer_name: answers.customer_name,
      email: answers.email,
      age_range: answers.age_range,
      time_losing_hair: answers.time_losing_hair,
      desired_outcomes: [answers.desired_outcome],
      personalization_response: answers.commitment_response,
      commitment_response: answers.reframe_response
        ? 'Sí (tras reconsiderar)'
        : answers.commitment_response,
      ship_date_response: answers.ship_date_response,
      completed_at: new Date().toISOString()
    };
  }

  function submitLead() {
    /* Name survives the redirect / back button / checkout via sessionStorage */
    try { sessionStorage.setItem('kitCustomerName', answers.customer_name); } catch (e) {}

    if (WORKER_URL) {
      try {
        fetch(WORKER_URL + WORKER_ROUTE, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(buildPayload()),
          keepalive: true   // lets the POST finish after we navigate away
        }).catch(function () {});
      } catch (e) { /* never block the redirect on a logging error */ }
    }
  }

  /* ---- Final loader: "Armando el kit de [Nombre]..." 1.5s, then redirect */
  function runFinal() {
    var name = answers.customer_name || '';
    $('kq-final-text').textContent = 'Armando el kit de ' + name + '...';
    var dest = REDIRECT_PATH + '?name=' + encodeURIComponent(name);
    setTimeout(function () { window.location.href = dest; }, 1500);
  }

  /* ---- Cap counter ----------------------------------------------------- */
  function initCap() {
    var numEl = $('kq-cap-num');
    if (!numEl) return;
    var KEY = 'kitCapState';
    var value = CAP_BASE;

    try {
      var raw = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (raw && raw.v === CAP_VERSION && typeof raw.n === 'number') {
        value = raw.n;
        /* New session => the count is 100 units lower than the last visit */
        if (!sessionStorage.getItem('kitCapSession')) value -= 100;
      }
    } catch (e) {}

    if (value < CAP_MIN) value = CAP_MIN;
    if (value > CAP_TOTAL) value = CAP_TOTAL;
    try { sessionStorage.setItem('kitCapSession', '1'); } catch (e) {}
    numEl.textContent = value;
    persist(value);

    /* While on the page: drop 1-3 every 3s / 5s / 4s (cycling) */
    var gaps = [3000, 5000, 4000], gi = 0;
    function tickDown() {
      if (value > CAP_MIN) {
        value = Math.max(CAP_MIN, value - (1 + Math.floor(Math.random() * 3)));
        numEl.textContent = value;
        persist(value);
      }
      gi = (gi + 1) % gaps.length;
      setTimeout(tickDown, gaps[gi]);
    }
    setTimeout(tickDown, gaps[0]);

    function persist(n) {
      try { localStorage.setItem(KEY, JSON.stringify({ v: CAP_VERSION, n: n })); } catch (e) {}
    }
  }

  /* ---- Wire up --------------------------------------------------------- */
  function init() {
    document.querySelectorAll('.kq-option[data-next]').forEach(function (el) {
      el.addEventListener('click', onOption);
    });
    document.querySelectorAll('[data-back]').forEach(function (el) {
      el.addEventListener('click', back);
    });
    $('kq-name').addEventListener('input', function () {
      this.classList.remove('kq-invalid');
      $('kq-name-error').classList.remove('kq-show');
      refreshForm();
    });
    $('kq-email').addEventListener('input', function () {
      this.classList.remove('kq-invalid');
      $('kq-email-error').classList.remove('kq-show');
      refreshForm();
    });
    $('kq-form').addEventListener('submit', onSubmit);

    initCap();
    track('s1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
